window.addEventListener("DOMContentLoaded", function () {
  setTimeout(AddSize, 1000);
  setTimeout(allowInput, 3000);
  setTimeout(productCus, 3000);
  setTimeout(Txtinput, 3000);
  setTimeout(Addinfo, 1000);
  setTimeout(ttInputCounter, 1000);
  
    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
     makeupTheDifferenceQty = getUrlParam('_amount');
  }
  if (makeupTheDifferenceQty != null) {
    $("input[name='quantity']").val(makeupTheDifferenceQty);
  }
    var isTypeurl = window.location.href;//判断是否是详情页
      if(isTypeurl.indexOf('products')!=-1){
      $('#product-add-to-cart').removeAttr('style');
      $('#product-add-to-cart').parent('.product-form__item--submit').removeAttr('style');
        if($('h1.product-single__title').text() !='Make Up The Price Difference'){
         if($('#customized_bigtur').length<1){
           $('#product-add-to-cart').bind({click:function(){
                alert('Product customization information failed to load, please refresh the page and add to the shopping cart again!');
                return false;
            }});   
         }    
        }   
      }
    if (isTypeurl.indexOf("cart") != -1) {
   if($('.bcpo-cart-item-line-price').find('span').attr('data-usd') !=undefined){
     $('#cart_submit').removeAttr("disabled");
   }     
}

  $(".size-close").click(function () {
    $("#mask,.size-popup-kk").css("display", "none");
  });

  $(".mi-close").click(function () {
    $("#mask-mi,.mi-popup-kk").css("display", "none");
  });

  $("#mask-mi").click(function () {
    $(this).css("display", "none");
    $("#mi-popup-kk").css("display", "none");
  });

  $(".size-cm").click(function () {
    $(this).addClass("size_checked");
    $("#inTable").addClass("size_hidden");
    $("#cmTable").removeClass("size_hidden");
    $(".size-in").removeClass("size_checked");
  });

  $(".size-in").click(function () {
    $(this).addClass("size_checked");
    $("#cmTable").addClass("size_hidden");
    $("#inTable").removeClass("size_hidden");
    $(".size-cm").removeClass("size_checked");
  });

  $("#AccessibleNav #SiteNav .site-nav--has-dropdown").mouseover(function () {
    var _offsetTop = $(this).position().top + 29;
    $(this)
      .find(".site-nav__dropdown")
      .css("top", _offsetTop + "px");
  });
});

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

function AddSize() {
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_default']");
  var modal =
    '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display:inline-block;"><span class="icon-f-09"></span> Size guide</a>';
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(AddSize, 1000);
  } else {
    obj.each(function () {
      $(this).find(".bigtur_div_extend").append(modal);
    });
  }
}

function allowInput() {
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_text']");
  obj.each(function () {
    var inputname = $(this).find("input").attr("name");
    var inputlength = $(this).find("input").attr("maxlength");
    $("input[name='" + inputname + "']").after(
      "<span class='allow_input' style='display:none;'><span></span> Left</span>"
    );
    showLeftInput(inputname, inputlength);
  });
}

//   显示剩余可输入字符数
function showLeftInput(inputname, totalchars) {
  $(".allow_input").nextAll().remove();
  $("input[name='" + inputname + "']").keyup(function () {
    var thischars = this.value.replace(/{.*}/g, "").length;
    $(this).next().show();
    if (thischars > totalchars) {
      var CharsToDel = thischars - totalchars;
      this.value = this.value.substring(0, this.value.length - CharsToDel);
    } else {
      $(this)
        .next()
        .children("span")
        .text(totalchars - thischars);
    }
  });
}

function productCus() {
  var _upload = $("input[name='properties[Upload Logo]']");
  if (_upload.attr("data-price") != null) {
    _upload.attr("accept", "image/png, image/jpeg,image/jpg");
    if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
      $("span[class='bigtur_title']").each(function () {
        var htm = $(this).html();
        var title = $(this).text();
        if (title == "Material:") {
          $(this).next().children().css("margin-left", "15px");
        }

        if (htm.indexOf("Team Logo") > -1 || htm.indexOf("Back Logo") > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
          htm =
            '<font size="-2">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>';
          $(this).append(htm);
        }
      });
    }
  } else {
    setTimeout(productCus, 3000);
  }
}

function getFileName(path) {
  var pos1 = path.lastIndexOf("/");
  var pos2 = path.lastIndexOf("\\");
  var pos = Math.max(pos1, pos2);
  if (pos < 0) {
    return path;
  } else {
    return path.substring(pos + 1);
  }
}

function Txtinput() {
  var _title = $("h1[class='product-single__title']").html();
  var regRule =/[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？！…―——_'"^%#@\·~&<>《》$=()+-/*{}[\]]|(^\s*)/g;
  if (_title.indexOf("Hat") !== -1) {
    var regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z]/g;
  }

  if ($("input[name='properties[Back Number]']").attr("data-price") != null) {
    //         不允许输入“|”
    $("input[type='text']").keyup(function () {
      if ($(this).val().indexOf("|") != -1) {
        $(this).val("");
      }
    });
    // 判断是ios还是安卓
    if (ios_or_android() == "ios") {
      $("input[type='text']").on("keyup", function () {
        var param = $(this).val();
        $(this).val(param.replace(regRule, ""));
      });
    } else {
      $("input[type='text']").on("input", function () {
        var param = $(this).val();
        $(this).val(param.replace(regRule, ""));
      });
    }
  } else {
    setTimeout(Txtinput, 3000);
  }
}


function ttInputCounter() {
  var ttInputCounter1 = $('#PageContainer .qty-group'); 
		ttInputCounter1.find('.minus-btn, .plus-btn').click(function(e) {
              var $input = $(this).parent().find('input');
              var count = parseInt($input.val(), 10) + parseInt(e.currentTarget.className === 'plus-btn' ? 1 : -1, 10);
          if(count >1 && count <3){
            $('.minus-btn').css("display","");  
          }else if(count == 1){
              $('.minus-btn').css("display","none"); 
          }
           $input.val(count).change();
          setTimeout("window.location.reload()", 1000);
  		});
  var ttInputCounter2 =$('.product-form__controls-group .quantity');
          ttInputCounter2.find('.minus-btn, .plus-btn').click(function(e) {
         var $input1 = $(this).parent().find('input');
         var count1 = parseInt($input1.val(), 10) + parseInt(e.currentTarget.className === 'plus-btn' ? 1 : -1, 10);
           $input1.val(count1).change();
  		});
}

function Addinfo() {
  var mi = $('input[type=radio][name="properties[Material]"]')
    .parent()
    .parent()
    .prev();
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_buttons']");
  if (obj.html() == "undefined" || obj == null) {
    setTimeout(Addinfo, 1000);
  } else {
    mi.append(
      '<a href="javascript:void(0);" class="scmi" style="color:red;margin-bottom: 10px;display: inline-block;" onclick="ClickMi()">&nbsp; Instruction<a/>'
    );
  }
}

function ClickMi() {
  $("#mask-mi").css("height", $(document).height());
  $("#mask-mi").css("width", $(document).width());
  $("#mask-mi").show();

  var $Popup = $(".mi-popup-kk");

  $Popup.css({
    left: ($("body").width() - $Popup.width()) / 2 + "px",
    top: ($(window).height() - $Popup.height() - 100) / 2 + "px",
    display: "block",
    position: "fixed",
  });
  $("#Img_MaterialInstruction").attr(
    "src",
    "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/8ce4276f966bb42d41b4dfaf96f67e53.gif?v=1615785804"
  );
}

/*
@功能：判断终端是ios还是安卓
 */
function ios_or_android() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if (isAndroid) {
    return "and";
  } else {
    return "ios";
  }
}

